<au-ribbon-environment
    *ngIf="!environment.production"
    title="Development"
>
</au-ribbon-environment>
<router-outlet></router-outlet>
